import { render, staticRenderFns } from "./slack-card.vue?vue&type=template&id=233e7c51&scoped=true&"
import script from "./slack-card.vue?vue&type=script&lang=ts&"
export * from "./slack-card.vue?vue&type=script&lang=ts&"
import style0 from "./slack-card.vue?vue&type=style&index=0&id=233e7c51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233e7c51",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
